import 'angular:locale/data:sv';
import 'angular:locale/data:sk';
import 'angular:locale/data:pl';
import 'angular:locale/data:nl';
import 'angular:locale/data:nb';
import 'angular:locale/data:fr';
import 'angular:locale/data:fi';
import 'angular:locale/data:en';
import 'angular:locale/data:de';
import 'angular:locale/data:da';
import 'angular:locale/data:en-US';
import './src/polyfills.ts';(globalThis.$localize ??= {}).locale = "___NG_LOCALE_INSERT___";
